import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import {
  Box,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const FunctionsTable = ({ functionData: rows, getData }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedId(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-root": {
                  fontWeight: 700,
                },
              }}
            >
              <TableCell>Name</TableCell>
              <TableCell>Function ID</TableCell>
              <TableCell>Entry Point</TableCell>
              <TableCell>URI</TableCell>
              <TableCell>Scheme</TableCell>
              <TableCell>Language</TableCell>
              <TableCell>Hostname</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length > 0 ? (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((data) => (
                  <TableRow key={data.id} sx={{ backgroundColor: "#fff" }}>
                    <TableCell>{data.name ? data.name : "N/A"}</TableCell>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{data.entrypoint}</TableCell>
                    <TableCell>{data.uri}</TableCell>
                    <TableCell>{data.scheme}</TableCell>
                    <TableCell>{data.language}</TableCell>
                    <TableCell>
                      {data.hostname ? data.hostname : "N/A"}
                    </TableCell>
                    <TableCell>
                      <MoreVertIcon
                        aria-describedby={id}
                        onClick={(e) => handleClick(e, data.id)}
                        sx={{ cursor: "pointer" }}
                      />
                      <Popover
                        id={id}
                        open={open && selectedId === data.id}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "center",
                          horizontal: "right",
                        }}
                      >
                        <Box
                          display="flex"
                          flexDirection={"column"}
                          gap={2}
                          alignItems={"center"}
                          padding={"0.75rem"}
                        >
                          <EditIcon
                            sx={{
                              width: "1.5rem",
                              color: "rgba(0,0,0,0.65)",
                              "&:hover": {
                                cursor: "pointer",

                                color: "rgba(0,0,0,0.95)",
                              },
                            }}
                            onClick={() => {
                              getData(data.id, "edit");
                              handleClose();
                            }}
                          />
                          <DeleteIcon
                            sx={{
                              width: "1.5rem",
                              color: "rgba(0,0,0,0.65)",
                              "&:hover": {
                                cursor: "pointer",

                                color: "rgba(0,0,0,0.95)",
                              },
                            }}
                            onClick={() => {
                              getData(data.id, "del");
                              handleClose();
                            }}
                          />
                        </Box>
                      </Popover>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow sx={{ backgroundColor: "transparent" }}>
                <TableCell colSpan={12} align="center">
                  No Functions created
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {rows && rows.length > 5 && (
        <TablePagination
          sx={{
            "& .MuiTablePagination-selectLabel": { display: "none" },
            "& .MuiTablePagination-input": { display: "none" },
          }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default FunctionsTable;
